module.exports = __webpack_public_path__ + "static/media/joinUsImage.b17d9cb2.webp";